"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    title: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    defaultOpen: {
      type: Boolean,
      default: true
    },
    // 不需要下拉功能
    withoutDrop: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: this.defaultOpen // 展开收起状态
    };
  },
  computed: {
    showContent: function showContent() {
      return this.withoutDrop ? true : this.isOpen;
    }
  },
  methods: {
    toggleOpen: function toggleOpen() {
      if (this.withoutDrop) {
        return false;
      }
      this.isOpen = !this.isOpen;
      this.$emit('slider');
    }
  }
};